import React from "react"
import styled, { keyframes } from "styled-components"

const l60 = keyframes`
    0% { rotate: 18deg; }
    to { rotate: -18deg; }
`

const l61 = keyframes`
    0% { rotate: -54deg; }
    to { rotate: 54deg; }
`

const LoaderWrapper = styled.div`
  display: inline-grid;
  width: 130px;
  aspect-ratio: 1;
  animation: ${l60} 0.8s linear infinite;
  transform: rotate(90deg);

  &:before,
  &:after {
    content: "";
    grid-area: 1/1;
  }

  &:before {
    clip-path: polygon(
      100% 50%,
      90.45% 79.39%,
      65.45% 97.55%,
      34.55% 97.55%,
      9.55% 79.39%,
      0% 50%,
      9.55% 20.61%,
      34.55% 2.45%,
      65.45% 2.45%,
      90.45% 20.61%,
      100% 50%,
      85.6% 24.14%,
      63.6% 8.15%,
      36.4% 8.15%,
      14.4% 24.14%,
      6% 50%,
      14.4% 75.86%,
      36.4% 91.85%,
      63.6% 91.85%,
      85.6% 75.86%,
      94% 50%,
      85.6% 24.14%
    );
    background: ${({ theme }) => theme.primary};
  }

  &:after {
    background: ${({ theme }) => theme.primaryLight};
    clip-path: polygon(100% 50%, 65.45% 97.55%, 9.55% 79.39%, 9.55% 20.61%, 65.45% 2.45%);
    margin: 23%;
    translate: -143% 0;
    transform-origin: right;
    animation: inherit;
    animation-name: ${l61};
  }
`

const LoaderOctagon: React.FC = () => {
  return <LoaderWrapper className="loader" />
}

export default LoaderOctagon
